import { ArgsType, Field } from '@nestjs/graphql'
import { BaseGetArgs } from '../base/baseGet.args'

@ArgsType()
export class PenNameGetArgs extends BaseGetArgs<PenNameGetArgs> {
  @Field(t => Boolean, { nullable: true })
  following?: boolean
}
